<template>
    <div>
        <div class="resourceRenewal-title">
            <div>{{$t( 'resourceLifecycle.resourceRenew' )}}</div>
        </div>
        <div class="resourceRenewal-top">
          <resource-basic-information-search></resource-basic-information-search>
        </div>
    </div>
</template>

<script>
  import ResourceBasicInformationSearch from '../resource_renewal/ResourceBasicInformationSearch'
    export default {
        name: 'ResourceRenewal',
        components: {
          ResourceBasicInformationSearch
        },
        data () {
            return {
            }
        },
        methods: {
        }
    }
</script>

<style scoped>
    .resourceRenewal-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .resourceRenewal-title>div:nth-child(1)
    {
        float:left;
    }
    .resourceRenewal-top
    {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_renewal/ResourceRenewal.vue